import Layout from 'antd/lib/layout';
import React, { useState } from 'react';
import Typography from 'antd/lib/typography';
import { CMRI_OVERVIEW_PAGE_CONST } from './constants';
import { ICmriOverviewSidebarFilters, useCmriOverviewSidebarFiltersContext } from './CmriOverviewSidebarFiltersContext';
import { ICreateSavedFilter } from 'src/components/sidebar-filters/saved-filter/interface';
import { SidebarWrapper } from 'src/components/sidebar-filters/SidebarWrapper';
import { SidebarFiltersGroupCollapse } from 'src/components/sidebar-filters/SidebarFiltersGroupCollapse';
import { CmriOverviewSidebarTabs } from './CmriOverviewSidebarTabs';
import { SaveCmriOverviewFiltersModal } from './SaveCmriOverviewFilterModal';

interface ICmriOverviewSidebarProps {
    collapsed: boolean;
    onCollapseChange: (value: boolean) => void;
    totalRecords?: number;
    onFilterChange: (filter: ICmriOverviewSidebarFilters) => void;
    gridComponent: React.ReactNode;
}

export const CmriOverviewSidebar: React.FC<ICmriOverviewSidebarProps> = ({
    collapsed,
    onCollapseChange,
    totalRecords,
    onFilterChange,
    gridComponent,
}) => {
    const {
        selectedSavedFilter,
        handleSavedFilterSelect,
        handleCreateSavedFilter,
        isCreateFilterLoading,
        handleUpdateSavedFilter,
        isUpdateFilterLoading,
    } = useCmriOverviewSidebarFiltersContext();

    const [saveFiltersModalOpen, setSaveFiltersModalOpen] = useState(false);

    const handleOpenSaveFiltersModal = (savedFilterData: ICreateSavedFilter | null) => {
        setSaveFiltersModalOpen(true);
        handleSavedFilterSelect(savedFilterData);
    };

    const handleCancelSaveFilters = () => {
        setSaveFiltersModalOpen(false);
        handleSavedFilterSelect(null);
    };

    const handleSaveFilters = async (filterData: ICreateSavedFilter) => {
        const upsertSavedFilter = filterData.id ? handleUpdateSavedFilter : handleCreateSavedFilter;

        await upsertSavedFilter(filterData);

        setSaveFiltersModalOpen(false);
        handleSavedFilterSelect(null);
    };

    return (
        <>
            <SidebarWrapper
                collapsed={collapsed}
                onCollapseChange={onCollapseChange}
                collapsedWidth={CMRI_OVERVIEW_PAGE_CONST.collapsedWidth}
                expandedWidth={CMRI_OVERVIEW_PAGE_CONST.expandedWidth}
            >
                <Layout.Content
                    style={{
                        padding: 0,
                        margin: 0,
                        height: '100%',
                    }}
                >
                    {!collapsed && (
                        <div style={{ padding: '14px 12px 8px' }}>
                            <Typography.Text>Total Records: {totalRecords}</Typography.Text>
                        </div>
                    )}
                    <SidebarFiltersGroupCollapse collapsed={collapsed} setCollapsed={onCollapseChange} selectedItemsCount={0} />

                    {!collapsed && (
                        <CmriOverviewSidebarTabs
                            onFilterChange={onFilterChange}
                            onOpenSaveFiltersModal={handleOpenSaveFiltersModal}
                            gridComponent={gridComponent}
                        />
                    )}
                </Layout.Content>
            </SidebarWrapper>

            {/* Modals goes here === */}
            {saveFiltersModalOpen && selectedSavedFilter && (
                <SaveCmriOverviewFiltersModal
                    isLoading={isCreateFilterLoading || isUpdateFilterLoading}
                    initialSavedFilter={selectedSavedFilter}
                    onCancel={handleCancelSaveFilters}
                    onSave={handleSaveFilters}
                />
            )}
        </>
    );
};
